module.exports = __webpack_public_path__ + "static/media/eitOp.d969013d.png";